import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Banner } from './components/banner/banner';
import { Numbers } from './components/numbers/numbers';
import { InnovationPillars } from './components/innovation-pillars/innovation-pillars';
import { First } from './components/first/first';
import { CoursesSection } from '../../shared/courses/components/courses-section/courses-section';
import { MentorshipBanner } from './components/mentorship-banner/mentorship-banner';
import { Reviews } from './components/reviews/reviews';
import { BlogPosts } from './components/blog-posts/blog-posts';
import { Community } from '../../shared/community/components/community/community';

@Component({
  selector: 'app-home',
  imports: [
    Banner,
    Numbers,
    InnovationPillars,
    First,
    CoursesSection,
    MentorshipBanner,
    Reviews,
    BlogPosts,
    Community,
  ],
  templateUrl: './home.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Home {}
